import { API_URI_CVTheque, BACKEND_ENV, getCVThequeENV } from '../config';

export const adapter4BackendProxy = async (axiosPrivate, url) => {
    let response1;
    if(getCVThequeENV() == 'remote'){
        response1 = await axiosPrivate.get(
            // * you don't have to add / to the starting of url
            '/proxy/'+ url,
        );
        return response1.data;
        // return responseData1;
    }
    else {
        response1 = await fetch(API_URI_CVTheque + url , {
            method: 'Get',
            headers: {
                // 'Content-Type': 'multipart/form-data',
                'accept': 'application/json',
                'env': BACKEND_ENV
            },
        });
        // responseData1 = await response1.json();
        return await response1.json();
    }
};